import Vue from 'vue';
import Toasted from 'vue-toasted';

Vue.use(Toasted, {
  position: 'bottom-left',
  iconPack: 'mdi',
  duration: 1500,
})